import { environment } from 'src/environments/environment';

export class PuntoIcono {

    idIcono: number;
    descripcion: string;
    imgPath: string;

    constructor(data: any) {

        this.idIcono = data['id_icono'];
        this.descripcion = data['name_icon'];
        const http = (environment.ssl) ? 'https' : 'http';
        this.imgPath = `${http}://${data['full_path']}`;
    }

}